import React, { useState } from "react";
import CategoryPicker from "./CategoryPicker";
import { useModalEsc, backdropClose } from "../utils/modalStack";

export default function SetNameModal({ mode = "set", categories = [], onCreate, onClose }) {
  const choose = mode === "choose";
  const [name, setName] = useState("");
  const [isSet, setIsSet] = useState(false); // teardown default = spare part
  const [category, setCategory] = useState("");
  const [newCategory, setNewCategory] = useState(null); // { name, code } | null

  useModalEsc(onClose);

  const ok = name.trim().length > 0 && category.trim().length > 0;
  const submit = () => {
    if (!ok) return;
    onCreate({
      name: name.trim(),
      isSet: choose ? isSet : true,
      category: category.trim(),
      // Carry the explicit code only when the selected category IS the pending new one.
      newCategoryCode: (newCategory && newCategory.name === category.trim()) ? newCategory.code : undefined,
    });
  };

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" onMouseDown={backdropClose(onClose)}>
      <div className="modal-box" onMouseDown={(e) => e.stopPropagation()}>
        <h2 className="modal-title">{choose ? "Buat barang baru" : "Buat SET baru"}</h2>
        <p className="page-sub" style={{ marginBottom: "var(--gap-lg)" }}>
          {choose
            ? "Barang baru dibuat dengan stok 0 di bawah kategori yang dipilih, dan langsung menjadi output. Stok pertamanya datang dari transformasi ini."
            : "SET baru dibuat dengan stok 0 di bawah kategori yang dipilih, dan langsung menjadi output. Stok pertamanya datang dari transformasi ini."}
        </p>
        <div className="form-row">
          <label className="form-label" htmlFor="setname-nama">{choose ? "Nama barang" : "Nama SET"}</label>
          <input id="setname-nama" className="form-input" value={name} autoFocus
            onChange={(e) => setName(e.target.value)} />
          {/* Disabled-control sweep (manual-testing report) — shared convention. */}
          {!name.trim() && <p className="form-hint" style={{ color: "var(--red)" }}>Wajib diisi.</p>}
        </div>
        {choose && (
          <div className="form-row">
            <label className="form-label">Jenis barang</label>
            <div className="seg">
              <button type="button" className={!isSet ? "active" : ""} onClick={() => setIsSet(false)}>Spare part</button>
              <button type="button" className={isSet ? "active" : ""} onClick={() => setIsSet(true)}>SET</button>
            </div>
          </div>
        )}
        <div className="form-row">
          <label className="form-label" htmlFor="setname-kategori">Kategori</label>
          <CategoryPicker
            id="setname-kategori"
            value={category}
            categories={categories}
            onChange={(name) => {
              setCategory(name || "");
              // Drop pending new-category if the user switches to a different category.
              setNewCategory((nc) => (nc && nc.name === name ? nc : null));
            }}
            onNewCategory={(cat) => setNewCategory(cat)}
          />
          {!category.trim() && <p className="form-hint" style={{ color: "var(--red)" }}>Wajib diisi.</p>}
        </div>
        <div className="modal-actions">
          <button type="button" className="btn" onClick={onClose}>Batal</button>
          <button type="button" className="btn btn-primary" disabled={!ok} onClick={submit}>Buat</button>
        </div>
      </div>
    </div>
  );
}
